<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="item.image ? item.image.url : ''"
      :title="
        !pgLoading ? ($i18n.locale == 'en' ? item.en.title : item.ar.title) : ''
      "
      :subtitle="
        !pgLoading ? ($i18n.locale == 'en' ? item.en.title : item.ar.title) : ''
      "
    >
    </Banner>

    <section class="account-area grey-bg2 pt-50">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 sidebar white-bg">
            <img
              :src="
                '/assets/img/logo/avatar.png'
              "
              loading="lazy"
              :alt="auth.first_name"
            />

            <input class="d-none" type="file" name="image1" id="image1" />
            <label for="image1">
              <span>{{ $t("auth.change_picture") }}</span>
            </label>

            <h2 class="mt-0">{{ auth.first_name }} {{ auth.last_name }}</h2>
            <p>{{ auth.email }}</p>
          </div>

          <div class="col-lg-8 about-area">
            <div
              class="donation-form white-bg mb-30 wow fadeInUp2 animated"
              data-wow-delay=".1s"
              style="
                visibility: visible;
                animation-delay: 0.1s;
                animation-name: fadeInUp2;
              "
            >
              <div class="section-title text-left mb-50">
                <h2>
                  {{ $t("auth.personal_info") }}
                </h2>
              </div>
              <div class="row payment-inner">
                <form action="#">
                  <div class="row">
                    <div class="col-12">
                      <div class="input-area mb-30">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('app.name')"
                          v-model="auth.first_name"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-12 col-lg-6">
                      <div class="input-area mb-30">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('auth.last_name')"
                          v-model="auth.last_name"
                        />
                      </div>
                    </div> -->
                    <div class="col-12">
                      <div class="input-area mb-30">
                        <input
                          type="email"
                          class="form-control"
                          :placeholder="$t('auth.email')"
                          v-model="auth.email"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-12">
                      <div class="input-area mb-20">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('auth.id_number')"
                          v-model="auth.id_number"
                        />
                      </div>
                    </div> -->
                    <div class="col-12">
                      <div class="input-area mb-20">
                        <vue-tel-input
                          v-model="auth.mobile"
                          :placeholder="$t('auth.mobile')"
                          :defaultCountry="'KW'"
                          v-on:country-changed="countryChanged"
                          style="
                            direction: ltr !important;
                            text-align: left !important;
                          "
                        >
                        </vue-tel-input>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-area mb-20">
                        <input
                          type="password"
                          class="form-control"
                          :placeholder="$t('auth.password')"
                          v-model="auth.password"
                        />
                      </div>
                    </div>
                    <div class="col-xl-12" style="z-index: 0">
                      <button
                        type="button"
                        class="theme_btn theme_btn_bg"
                        @click="updateProfile()"
                      >
                        {{ $t("auth.save") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div
              class="account-past-donations donation-form white-bg mb-30 wow fadeInUp2 animated"
              data-wow-delay=".1s"
              style="
                visibility: visible;
                animation-delay: 0.1s;
                animation-name: fadeInUp2;
              "
            >
              <div class="section-title text-left mb-50">
                <h2>{{ $t("app.past_donations") }}</h2>
              </div>
              <div class="row payment-inner">
                <!-- Project Item -->
                <!-- <div class="col-xl-6 col-lg-6 col-md-6"
                                        v-for="(item, index) in 6" 
                                        :key="index" >
                                        <div class="cases grey-bg2 mb-30 wow fadeInUp2 animated" data-wow-delay='.3s'>
                                            <div class="cases__box pos-rel">
                                                <div class="cases__box--img">
                                                    <img src="/assets/img/cases/02.jpg" alt="" loading="lazy" />
                                                </div>
                                            </div>
                                            <div class="cases__content mt-4">
                                                <h3><a href="#">سقيا الماء</a></h3>
                                                <div class="cases-progress">
                                                    <p class="funding">{{$t('auth.donate_by')}} <span>1000 {{$t('app.dinar')}}</span></p>                                        
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import iziToast from "izitoast";

export default {
  name: "Profile",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    VueTelInput,
  },
  data() {
    return {
      item: {
        image: {
          url: "/assets/img/bg/login-banner.jpg",
        },
        en: {
          title: "Profile",
        },
        ar: {
          title: "حسابي",
        },
      },

      refs: "me",
      btnLoading: false,
      //
      auth: {
        access_token: "",
        first_name: "",
        last_name: "",
        email: "",
        ccode: "",
        mobile: "",
        avatar: "",
        user_id: "",
      },
      locale: "ar",
      pgLoading: true,

      info: "",
      projects: [],
      // orphans: [],
      // preachers: [],
      reliefs: [],
      // endowments: [],
      tab: 1,
    };
  },
  mounted() {},
  created() {
    // Auth
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("user_id")) {
      this.auth.user_id = localStorage.getItem("user_id");
    }
    if (localStorage.getItem("first_name")) {
      this.auth.first_name = localStorage.getItem("first_name");
    }
    if (localStorage.getItem("last_name")) {
      this.auth.last_name = localStorage.getItem("last_name");
    }
    if (localStorage.getItem("avatar")) {
      this.auth.avatar = localStorage.getItem("avatar");
    }
    if (localStorage.getItem("email")) {
      this.auth.email = localStorage.getItem("email");
    }
    if (localStorage.getItem("mobile")) {
      this.auth.mobile = localStorage.getItem("mobile");
    }

    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }
    this.fetchData();
  },
  methods: {
    //
    updateProfile() {
      // if (
      //   !this.auth.mobile ||
      //   !this.auth.id_number ||
      //   !this.auth.password ||
      //   !this.auth.ccode ||
      //   !this.auth.email
      // ) {
      //   alert(this.$t("app.allRequired"));
      //   return;
      // }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/me/" + this.auth.user_id,
        method: "PUT",
        data: {
          // row
          first_name: this.auth.first_name,
          last_name: this.auth.last_name,
          email: this.auth.email,
          ccode: this.auth.ccode,
          mobile: this.auth.mobile,
          id_number: this.auth.id_number,
          password: this.auth.password,

          // image
          image: this.auth.avatar,
        },
      };

      this.$axios(options)
        .then(() => {
          this.btnLoading = false;

          iziToast.success({
            icon: "ti-check",
            title: "",
            message:
              this.locale == "ar"
                ? "تم تحديث الحساب الشخصي بنجاح"
                : "Profile Updated Successfully",
          });

          localStorage.setItem("first_name", this.auth.first_name);
          localStorage.setItem("last_name", this.auth.last_name);
          localStorage.setItem("avatar", this.auth.avatar);
          localStorage.setItem("ccode", this.auth.ccode);
          localStorage.setItem("mobile", this.auth.mobile);
          localStorage.setItem("email", this.auth.email);
          localStorage.setItem("id_number", this.auth.id_number);

          this.$router.push({ name: "home" });
          window.location.reload();

          // this.closePopup();
        })
        .catch(() => {
          this.btnLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: this.$t("app.error_contact_us"),
          });
        })
        .finally(() => {
          // this.closePopup();
        });
    },

    //
    fetchData() {
      this.pgLoading = true;
      this.$axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/" + this.refs,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          // console.log(res.data);
          this.pgLoading = false;
          this.info = res.data.info;
          this.projects = res.data.projects.rows;
          // this.orphans = res.data.orphans.rows;
          this.preachers = res.data.preachers.rows;
          this.reliefs = res.data.reliefs.rows;
          // this.endowments = res.data.endowments.rows;

          // pagination
        })
        .catch((err) => {
          // 401 Forbidden
          if (err.response && err.response.status == 401) {
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          }
        })
        .finally(() => {});
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("ccode");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },
    countryChanged(country) {
      this.ccode = country.dialCode;
    },

    changeTab: function (id) {
      this.tab = id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
  <style src="vue-tel-input/dist/vue-tel-input.css"></style>  

<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}
.vue-tel-input {
  height: 50px;
}
.vue-tel-input .vti__dropdown {
  width: 70px !important;
}
.vue-tel-input .vti__dropdown-arrow {
  width: 50px !important;
  margin-top: -10px !important;
  position: static !important;
}

.vti__dropdown-list.below {
  z-index: 99 !important;
}
</style>

